import { render, staticRenderFns } from "./ProgramaUniversidadCertificadosManager.vue?vue&type=template&id=7c6ed84e"
import script from "./ProgramaUniversidadCertificadosManager.vue?vue&type=script&lang=js"
export * from "./ProgramaUniversidadCertificadosManager.vue?vue&type=script&lang=js"
import style0 from "./ProgramaUniversidadCertificadosManager.vue?vue&type=style&index=0&id=7c6ed84e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports